const PaymentMethod = {
    CASH: 'CASH',
    CREDIT_CARD: 'CREDIT_CARD',
    DEBIT_CARD: 'DEBIT_CARD',
    PIX: 'PIX',
    COURTESY: 'COURTESY',
    SUBSCRIPTION: 'SUBSCRIPTION',
    // Reserva paga no agendamento e abatida na venda; só existe como parte do pagamento misto.
    RESERVATION: 'RESERVATION'
}

export default PaymentMethod;
